import MemberGate from "./MemberGate";

export default MemberGate;
